<template>
  <div>
    <mv-count-down
      @startCallback="startCallback"
      @endCallback="endCallback"
      :tip-text="countContext"
      :start-time="startTime"
      :end-time="thisEndTime"
      :end-text="endText"
      :day-txt="dayTxt"
      :hour-txt="hourTxt"
      :minutes-txt="minutesTxt"
      :seconds-txt="secondsTxt"
      :is-start="isStart"
      :style="_style"
      :key="this.endTime"
      :simple="simple"
    />
  </div>
</template>

<script>
import { getCache } from '@/utils/cache'
import MvCountDown from 'cl-mv-count-down'
import DateUtil from '../../utils/date'

export default {
  name: 'CountDown',
  props: {
    endTime: {
      type: [String, Number], // 时间戳的数据格式
      required: true
    },
    countContext: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: '13px'
    },
    // 简洁模式
    simple: {
      type: Boolean,
      default: false
    },
    // 自定义显示文字:天
    dayTxt: {
      type: String,
      default: '天'
    },
    // 自定义显示文字:时
    hourTxt: {
      type: String,
      default: '时'
    },
    // 自定义显示文字:分
    minutesTxt: {
      type: String,
      default: '分'
    },
    // 自定义显示文字:秒
    secondsTxt: {
      type: String,
      default: '秒'
    }
  },
  components: {
    MvCountDown
  },
  computed: {
    _style() {
      return { fontSize: this.fontSize }
    }
  },
  data() {
    return {
      diffTime: 0, // 与服务器之间的时间差
      startTime: 0, // 开始时间（时间戳）
      thisEndTime: 0, // 完成的时间（时间戳）
      endText: '---', // 倒计时完成的提示文本
      isStart: false // 控制倒计时开始的时机（异步请求完成开启）
    }
  },
  created() {
    this.initDiffTime()
    this.initTime()
  },
  watch: {
    endTime: function(val) {
      this.initTime()
    }
  },
  methods: {
    initDiffTime() {
      const curTime = new Date().getTime()
      getCache('sys', 'diffTime', '/time/diff', { curTime: curTime }).then(res => {
        this.diffTime = res
      })
    },
    /**
     * 设置结束时间推迟多少秒并转时间戳
     * @param value
     */
    initTime() {
      let e = this.endTime
      if (typeof e === 'string' || e instanceof String) {
        e = DateUtil.parse(this.endTime).getTime()
      }
      if (e > 0) {
        this.startTime = new Date().getTime() + this.diffTime
        this.thisEndTime = e
        this.isStart = true
      }
    },
    /**
     * 开始倒计时回调
     * @param x
     */
    startCallback(x) {
      this.$emit('start')
    },
    /**
     * 结束倒计时回调
     */
    endCallback() {
      this.$emit('end')
    }
  }
}
</script>
